import { z } from 'zod'

export const PricingBasis = z.enum(['gross', 'net'])
export type PricingBasis = z.infer<typeof PricingBasis>

export const TaxReason = z.enum(['small_business_exempt', 'domestic', 'reverse_charge', 'eu_b2c', 'non_eu'])
export type TaxReason = z.infer<typeof TaxReason>

const cents = z.number().int()

// GET /cart/{id}/totals: what checkout charges this account for the cart. On
// the net basis gross_cents equals net_cents and vat_cents is 0.
export const CartTotals = z.object({
  pricing_basis: PricingBasis,
  tax_rate: z.number(),
  tax_reason: TaxReason,
  net_cents: cents,
  vat_cents: cents,
  gross_cents: cents,
  // Gross per billing cycle; only the intervals in the cart are present.
  by_interval: z.object({
    monthly: cents.optional(),
    quarterly: cents.optional(),
    'half-annually': cents.optional(),
    annually: cents.optional()
  })
})

export type CartTotals = z.infer<typeof CartTotals>
